//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let cardStaticsMap = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'cardMap',//办卡量统计
        component: _import('cardMap/cardMap'),
        name: 'cardMap',
        meta: { 
          title: '办卡量统计',
          icon: 'widgets'
        }
      },{
        path: 'cardProvince',//省市数据
        component: _import('cardMap/cardProvince'),
        name: 'cardProvince',
        meta: { 
          title: '办卡量统计',
          icon: 'widgets'
        }
      },{
        path: 'cardDot',//地市数据
        component: _import('cardMap/cardDot/index'),
        name: 'cardDot',
        meta: { 
          title: '办卡量统计',
          icon: 'widgets'
        }
      },
      {
        path: 'cardSite',//搜索主界面
        component: _import('cardMap/cardSite'),
        name: 'cardSite',
        meta: {
          title: '搜索主页',
          icon: 'widgets'
        }
      },
      {
        path: 'result',//搜索结果页
        component: _import('cardMap/siteResult'),
        name: 'siteResult',
        meta: {
          title: '查询结果',
          icon: 'widgets'
        }
      }
    ]
  }
]
export default cardStaticsMap;